import { useEffect, useRef } from "react";

import { useSelector } from "react-redux";

// Components

import TextInput from "../../../UI/FormInput/TextInput";
import DropDownInput from "../../../UI/FormInput/DropDownInput";
import CalendarInput from "../../../UI/FormInput/CalendarInput";
import NumberInput from "../../../UI/FormInput/NumberInput";
import MaskInput from "../../../UI/FormInput/MaskInput";
import FormInputGroup from "../../../UI/FormInputGroup/FormInputGroup";
import RadioInput from "../../../UI/FormInput/RadioInput";

// Utilities

import { formatDropDownOptions } from "../../../../utilities/helper-functions";

import { initialValues } from "./InitialValues";

export default function BankReferenceFields({ formik }) {
  const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

  const prevTipoBanco = useRef();

  // Reset field values when tipoBanco changes

  useEffect(() => {
    const tipoBanco = formik.values?.bankReference?.tipoBanco;

    if (prevTipoBanco.current && prevTipoBanco.current !== tipoBanco) {
      formik.setFieldValue('bankReference', {
        ...initialValues.bankReference,
        tipoBanco,
      });
    }

    prevTipoBanco.current = tipoBanco;
  }, [formik.values?.bankReference?.tipoBanco]);

  // Get Bank Description by Code

  useEffect(() => {
    const codigo = formik.values?.bankReference?.banco?.codigo;
    const tipoBanco = formik.values?.bankReference?.tipoBanco;

    if (codigo && tipoBanco) {
      const bankList =
        tipoBanco === 'nacional'
          ? dropDownOptions?.data?.nationalBanks
          : dropDownOptions?.data?.internationalBanks;

      const item = bankList?.find((item) => item.value === codigo);

      formik.setFieldValue(
        `bankReference.banco.descripcion`,
        item?.name
      );
    }
  }, [
    formik.values?.bankReference?.banco?.codigo,
    formik.values?.bankReference?.tipoBanco,
    dropDownOptions?.data
  ]);

  // Get Figures Type Description by Code

  useEffect(() => {
    if (formik.values?.bankReference?.tipoCifras?.codigo) {
      const code = formik.values?.bankReference?.tipoCifras?.codigo;
      const item = dropDownOptions?.data?.typeFigures?.find(
        (item) => item.value === code
      );
      formik.setFieldValue(
        `bankReference.tipoCifras.descripcion`,
        item?.name
      );
    }
  }, [formik.values?.bankReference?.tipoCifras?.codigo]);

  // Get Calification Description by Code

  useEffect(() => {
    if (formik.values?.bankReference?.calificacion?.codigo) {
      const code = formik.values.bankReference.calificacion.codigo;
      const item = dropDownOptions?.data?.qualifyingBankReferences?.find(
        (item) => item.value === code
      );
      formik.setFieldValue(
        `bankReference.calificacion.descripcion`,
        item?.name
      );
    }
  }, [formik.values?.bankReference?.calificacion?.codigo]);

  return (
    <div>
      <h3 className="multiple-input-heading">
        Referencia Bancaria
      </h3>


      <RadioInput
        formik={formik}
        fieldName={'bankReference.tipoBanco'}
        label={'Seleccione un tipo de banco'}
        options={[{ label: 'Nacional', value: 'nacional' }, { label: 'Internacional', value: 'internacional' }]}
        isGroup={true}
        isRequired={true}
      />

      {formik.values?.bankReference?.tipoBanco &&
        <FormInputGroup>
          <CalendarInput
            formik={formik}
            fieldName={`bankReference.fechaConstancia`}
            label={"Fecha de Constancia"}
            // minDate={getCurrentDateMinusMonths(1)}
            maxDate={new Date()}
            isRequired={true}
          />

          <DropDownInput
            formik={formik}
            fieldName={`bankReference.banco.codigo`}
            label={"Banco"}
            options={formik.values?.bankReference?.tipoBanco === 'nacional' ? formatDropDownOptions(dropDownOptions?.data?.nationalBanks) : formatDropDownOptions(dropDownOptions?.data?.internationalBanks)}
            isRequired={true}
          />

          <DropDownInput
            formik={formik}
            fieldName={`bankReference.tipoCuenta`}
            label={"Tipo de Cuenta"}
            options={formatDropDownOptions(dropDownOptions?.data?.accountTypes)}
            isRequired={true}
          />

          {formik.values?.bankReference?.tipoBanco === 'nacional' &&
            <MaskInput
              formik={formik}
              fieldName={'bankReference.numeroCuenta'}
              label={'Número de Cuenta'}
              mask={'99999999999999999999'}
              isRequired={true}
            />}

          {formik.values?.bankReference?.tipoBanco === 'internacional' &&
            <TextInput
              formik={formik}
              fieldName={`bankReference.numeroCuenta`}
              label={"Número de Cuenta"}
              maxLength={30}
            />}

          <CalendarInput
            formik={formik}
            fieldName={`bankReference.fechaApertura`}
            label={"Fecha de Apertura"}
            maxDate={new Date()}
            isRequired={true}
          />

          <NumberInput
            formik={formik}
            fieldName={`bankReference.numeroCifras`}
            label={"Número de Cifras Promedio"}
            isRequired={true}
          />

          <DropDownInput
            formik={formik}
            fieldName={`bankReference.tipoCifras.codigo`}
            label={"Tipo de Cifras Promedio"}
            options={formatDropDownOptions(dropDownOptions?.data?.typeFigures)}
            isRequired={true}
          />
  
          <DropDownInput
            formik={formik}
            fieldName={`bankReference.calificacion.codigo`}
            label={"Calificación"}
            options={formatDropDownOptions(dropDownOptions?.data?.qualifyingBankReferences)}
            isRequired={true}
          />
        </FormInputGroup>}

        {formik.values?.bankReference?.tipoBanco &&
        <TextInput
          formik={formik}
          fieldName={`bankReference.observacion`}
          label={"Observación"}
          maxLength={120}
        />}
    </div>
  );
}
